import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {TranslationMessagesPageData} from "./translation-messages";
import {TranslationMessagesList} from "./translations-messages.list";
import {TranslationMessagePage} from "./translation-messages-page";
/**
 * A server used to mock a paged data result from a server
 */
@Injectable()
export class TranslationMessagesResultService {
    listData:any;
    loginData;
    rows = {};
    applicationsDashboardData = {};

    constructor(){}

    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    public getResults(page: TranslationMessagePage,listData): Observable<TranslationMessagesPageData<TranslationMessagesList>> {
        this.listData = listData;
        return Observable.of(listData).map(data => this.getPageData(page));
    }

    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    private getPageData(page: TranslationMessagePage): TranslationMessagesPageData<TranslationMessagesList> {
        let pageData = new TranslationMessagesPageData<TranslationMessagesList>();
        let offset = this.listData.offset;
        let raw = [];
        for(let l in this.listData){
            if(Object.keys(this.listData[l]).length > 0){
                raw[offset+parseInt(l)] = this.listData[l];
            }
        }
        if(this.listData.totalCount){
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        let start = page.pageNumber * page.size;
        let end = Math.min((start + page.size), page.totalElements);

        
        for (let i = start; i < end; i++) {
            if(raw[i]){
                let jsonObj = raw[i];
                if(jsonObj){
                
                    let list = new TranslationMessagesList(jsonObj['id'], jsonObj['key'], jsonObj['english'], jsonObj['seletedLanguage'], jsonObj['actionFlag']);
                    pageData.data.push(list);
                }
            } 
        }
        pageData.page = page;
        return pageData;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/translation-messages/translation-messages/translationResultService.ts